/**
 * /checkout/cancel — patient bailed from Stripe Checkout.
 */
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";

export default function CheckoutCancel() {
  const [params] = useSearchParams();
  const programSlug = params.get("program");

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center px-6 py-12">
      <div
        data-testid="checkout-cancel-page"
        className="max-w-lg w-full rounded-2xl border border-slate-800 bg-slate-900/40 p-8 text-center"
      >
        <XCircle className="w-12 h-12 text-slate-500 mx-auto mb-3" />
        <div className="text-2xl font-bold text-slate-100 mb-2">Checkout cancelled</div>
        <p className="text-sm text-slate-400 mb-6">
          No charge was made. You can return to the program page anytime to complete the checkout.
        </p>
        <Link
          to={programSlug ? `/buy/${programSlug}` : "/"}
          className="inline-flex items-center gap-2 rounded-full bg-blue-600 text-white text-sm font-semibold px-4 py-2 hover:bg-blue-700"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to the program
        </Link>
      </div>
    </div>
  );
}
